import styled from 'styled-components'
import Footer from '../../components/footer/Footer'
import Header from '../../components/header/Header'
import { BiomarkersContainer, Container, Title } from '../recommendations/Recommendations'
import MeasuredBiomarkers from '../../components/measuredBiomarkers/MeasuredBiomarkers'
import AboutBiomarker from '../../components/modals/AboutBiomarker'
import { useNavigate } from 'react-router-dom'

const Main = () => {
    return (<div style={{maxWidth: '800px', margin: '0 auto'}}>

            <h1>Terms of Usage</h1>

            <h2>1. Introduction</h2>
            <p>Welcome to the Swiss Medical Laboratory. This document outlines the terms under which you may use our services. These terms apply to all users and visitors of our services.</p>

            <h2>2. Definitions</h2>
            <ul>
                <li><strong>Services:</strong> Any procedures, tests, or consultations provided by Swiss Medical Laboratory.</li>
                <li><strong>Users:</strong> Individuals or entities that utilize the services.</li>
                <li><strong>Data:</strong> Any personal or medical information submitted or generated through our services.</li>
            </ul>

            <h2>3. Purpose</h2>
            <p>Our services are designed for medical diagnostic purposes. All results and consultations are meant to assist in healthcare decisions and should be interpreted by qualified healthcare professionals.</p>

            <h2>4. Registration and User Accounts</h2>
            <p>To access certain services, users may need to register and create an account. Users must provide accurate information and are responsible for maintaining the security of their account credentials.</p>

            <h2>5. Accuracy of Information</h2>
            <p>We strive for accuracy and reliability. However, we do not guarantee the correctness or completeness of any information, including test results. Users should always consult with a healthcare professional regarding the results.</p>

            <h2>6. Data Privacy and Security</h2>
            <p>We adhere to Swiss laws and best practices concerning data protection and privacy. Your data is stored securely and will not be shared with third parties without explicit consent, except when required by law.</p>

            <h2>7. User Responsibilities</h2>
            <p>Users are responsible for:</p>
            <ul>
                <li>Providing accurate personal and medical information.</li>
                <li>Complying with all instructions and recommendations regarding the use of our services.</li>
                <li>Keeping account credentials confidential.</li>
            </ul>

            <h2>8. Consent</h2>
            <p>By using our services, you grant us the right to process your samples and data for diagnostic purposes. You can withdraw this consent at any time, but actions taken before withdrawal remain valid.</p>

            <h2>9. Payment</h2>
            <p>Some of our services may require payment. Users agree to provide accurate payment information and authorize Swiss Medical Laboratory to charge the provided amount for the services.</p>

            <h2>10. Limitation of Liability</h2>
            <p>We shall not be liable for any direct, indirect, or consequential damages arising out of the use or inability to use our services. This includes, but isn't limited to, misinterpretations, inaccuracies, or health decisions based on our results.</p>

            <h2>11. Termination</h2>
            <p>We reserve the right to suspend or terminate user accounts and access to services at our discretion, particularly in cases of violations of these terms.</p>

            <h2>12. Changes to Terms</h2>
            <p>We may modify these terms at any time. It is the user's responsibility to regularly review and remain informed about any changes.</p>

            <h2>13. Intellectual Property</h2>
            <p>All content, including website design, text, graphics, and other materials are owned by or licensed to Swiss Medical Laboratory. Unauthorized use or reproduction is prohibited.</p>

            <h2>14. Applicable Law</h2>
            <p>This agreement is governed by Swiss law. Any disputes will be addressed in Swiss courts.</p>

            <h2>15. Feedback and Complaints</h2>
            <p>We welcome feedback. Users can contact us with suggestions, concerns, or complaints regarding our services.</p>

            <h2>16. Miscellaneous</h2>
            <p>If any provision of these terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary for the terms to otherwise remain in full force and effect.</p>

            <p>For any further inquiries or clarifications regarding these terms, please contact us.</p>

        </div>
    )
}

export default Main
